module.exports = __webpack_public_path__ + "img/triangle.0b22e7a5.png";